import React, { FC } from 'react';
import { PlacesType } from 'react-tooltip';
import { TooltipWrapper } from './style';
type Props = {
  children?: React.ReactNode;
  content: string;
  id: string;
  place?: PlacesType;
  openOnClick?: boolean;
};

const Tooltip: FC<Props> = ({ children, id, content, place = 'top', openOnClick }: Props) => {
  return (
    <TooltipWrapper anchorSelect={`#${id}`} content={content} place={place} openOnClick={openOnClick}>
      {children}
    </TooltipWrapper>
  );
};

export default Tooltip;
